export default __webpack_public_path__ + "static/media/dashboard-button-credit.5fb7d6e6.png";